import { ThunkAction } from 'redux-thunk';
import { RootState } from 'old-store/store';
import { IGallery } from 'old-store/types/gallery';

type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, any>;

type GalleryPayload = IGallery | Partial<IGallery> | undefined;

export const setCurrentGallery =
  (payload: GalleryPayload): AppThunk =>
  (dispatch) => {
    dispatch({ type: 'set_current_gallery', payload });
  };
